import { render, staticRenderFns } from "./OperaGoodsBrandWindow.vue?vue&type=template&id=5f641f66&scoped=true&"
import script from "./OperaGoodsBrandWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsBrandWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsBrandWindow.vue?vue&type=style&index=0&id=5f641f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f641f66",
  null
  
)

export default component.exports